import {
  getPostBy as getPostByRes,
  approvePostBy as approvePostByRes,
} from "../apis/post";
/**
 * 获取验证的post信息
 * @param token url上的token
 * @returns {*}
 */
export async function getPostBy({ token }) {
  const { data } = await getPostByRes({ token });
  return data;
}
/**
 * 审核信息
 * @param token url上的token
 * @param status 评审状态 2：接受，3：拒绝
 * @returns {*}
 */
export async function approvePostBy({ token, status }) {
  const { data } = await approvePostByRes({ token, status });
  return data;
}



// WEBPACK FOOTER //
// ./src/services/post.js